module.exports = __webpack_public_path__ + "img/dlf.pt-volvo-logo-png-4480152.c2953ba6.png";